import { render, staticRenderFns } from "./SmallWithIcon.vue?vue&type=template&id=615937f1&scoped=true&"
import script from "./SmallWithIcon.vue?vue&type=script&lang=js&"
export * from "./SmallWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./SmallWithIcon.vue?vue&type=style&index=0&id=615937f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615937f1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconCollection: require('/vercel/path0/components/general/IconCollection.vue').default,ArrowButton: require('/vercel/path0/components/general/ArrowButton.vue').default,SelectableBgColor: require('/vercel/path0/components/general/SelectableBgColor.vue').default})
